import PropTypes from "prop-types";

import InfoSvg from "assets/svg/info.svg";
import EndeksaLogo from "assets/svg/endeksa_logo.svg";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import Title from "components/listing-detail/title";
import ContentOuterWrap from "components/listing-detail/content-outer-wrap";
import ListingDetailDistrictReport from "components/listing-detail/district-report";

import styles from "./styles.module.css";

const RegionReport = ({ listingData, districtReportPriceInfos, districtReportDemographicInfos }) => {
  const {
    properties: info,
    location: { town },
  } = listingData || {};
  const listingSquareValue = info.find((item) => ["gross_square", "square"].includes(item.key))?.value;
  const listingEstateType = info?.filter((item) => item.key === "category")[0].value;
  const listingTradeTypeValue = info?.find((item) => item.key === "trade_type")?.value;
  const { townName } = districtReportDemographicInfos || {};

  const handleSetGa4Event = () => {
    Ga4WithEventParameters({
      eventName: "click_widget",
      eventParameters: { widget: `bolge-raporu||endeksa` },
    });
  };

  return (
    <div className={styles.wrapper} id="bolge-raporu" data-scroll-selector>
      <div className={styles.titleWrapper}>
        <Title>Bölge Raporu</Title>
        <span
          // eslint-disable-next-line react/no-unknown-property
          tooltip="Bu modülde incelediğiniz ilanın bulunduğu bölgeye ait evlerin ortalama fiyatları ve bu bölgenin
                demografik yaşam özelliklerini görebilirsiniz."
          // eslint-disable-next-line react/no-unknown-property
          flow="right"
          className={styles.infoIcon}
        >
          <InfoSvg width="19" height="19" />
        </span>
      </div>
      <div className={styles.townInfo}>
        <p>{townName || `${town?.name} Mahallesi`}</p>
        {(listingSquareValue || listingEstateType) && (
          <span>| {`${listingSquareValue || ""} ${listingEstateType || ""} için`}</span>
        )}
      </div>
      <ContentOuterWrap>
        <ListingDetailDistrictReport
          listingTradeTypeValue={listingTradeTypeValue}
          listingEstateType={listingEstateType}
          districtReportPriceInfos={districtReportPriceInfos}
          districtReportDemographicInfos={districtReportDemographicInfos}
          listingData={listingData}
        />

        <EndeksaLogo />
        <div className={styles.endeksaAbout}>
          Bölge Raporu, Endeksa’dan almış olduğumuz veriler ışığında oluşturulmuştur. Aradığınız bölge ile ilgili
          detaylı rapora erişmek için
          <a
            href="https://www.endeksa.com/tr/"
            className={styles.endeksaRedirect}
            target="_blank"
            rel="noreferrer"
            onClick={handleSetGa4Event}
          >
            tıklayın.
          </a>
        </div>
      </ContentOuterWrap>
    </div>
  );
};

RegionReport.propTypes = {
  listingData: PropTypes.object,
  districtReportDemographicInfos: PropTypes.object,
  districtReportPriceInfos: PropTypes.object,
};

export default RegionReport;
